const routes = [
  {
    path: '/',
    name: 'Home',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Home.vue')
  }, {
    path: '/goodsDetail',
    name: 'GoodsDetail',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/GoodsDetail.vue')
  }, {
    path: '/user',
    name: 'User',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/User.vue')
  }, {
    path: '/order',
    name: 'Order',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Order.vue')
  }, {
    path: '/balanceRecord',
    name: 'BalanceRecord',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/BalanceRecord.vue')
  }, {
    path: '/content',
    name: 'Content',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Content.vue')
  }, {
    path: '/secret',
    name: 'Secret',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Secret.vue')
  }, {
    path: '/setting',
    name: 'Setting',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Setting.vue')
  }, {
    path: '/contact',
    name: 'Contact',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Contact.vue')
  }, {
    path: '/goodsIsBo',
    name: 'GoodsIsBo',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/GoodsIsBo.vue')
  }, {
    path: '/success',
    name: 'Success',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Success.vue')
  }, {
    path: '/website',
    name: 'Website',
    mate: {
      keepAlive: true
    },
    component: () => import('../views/pc/Website.vue')
  }
]

export default routes
